import {Component} from "@angular/core";
import {SurchargeSearchModel} from "../surcharge-search.model";
import {SurchargeEntityModel} from "../surcharge-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-surcharge-search-page",
    templateUrl: "./surcharge-search-page.component.html",
    providers: [provideSearchModel(SurchargeSearchModel), provideEntityModel(SurchargeEntityModel)]
})
export class SurchargeSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
